module.exports = __webpack_public_path__ + "img/back.2ea4883a.png";